import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import ChapterController from "../../components/ui/ChapterController";
import Header from "../../components/ui/Header";
import { useChapterDetail } from "../../hooks/useChapterDetail";
import { useEpisodes } from "../../hooks/useEpisodes";

const NovelReader: React.FC = () => {
  const { slug, chapterIndex ,lang} = useParams<{ slug: string; chapterIndex: string , lang: string}>();
  const location = useLocation();
  const navigate = useNavigate();
  const { detail } = location.state || {};
  const [hideUI, setHideUI] = React.useState(false);
  const novelStyle = useSelector((state: any) => state.setting.novelStyle);
  console.log({chapterIndex});
  
  // Fetch chapter list
  const { episodes: chaptersArr } = useEpisodes(
    "novel",
    detail?.id || "",
    slug || ""
  );

  const currentIdx = Number(chapterIndex);

  // Fetch chapter detail
  const { chapter: currentChapter, isLoading, refetch } = useChapterDetail(
    "novel",
    detail?.id || "",
    chapterIndex || ""
  );

  // Effect để fetch lại data khi URL thay đổi
  useEffect(() => {
    refetch();
  }, [chapterIndex, refetch]);

  const goToChapter = (idx: number) => {
    if (idx < 1 || idx > chaptersArr.length) return;

    navigate(`/${lang}/novel/${slug}/${idx}/`, {
      state: { detail },
      replace: true
    });
  };

  if (!detail) {
    return <div className="text-white p-8">Không tìm thấy thông tin truyện.</div>;
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center min-h-[300px]">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      );
    }

    if (!currentChapter) {
      return <div className="text-center p-8">Không tìm thấy nội dung chương.</div>;
    }

    return (
      <>
        <div className="mb-4 text-center text-lg">
          Chương {currentChapter.index}: {currentChapter.title || ""}
        </div>
        <div 
          className="chapter-content bg-gray-900 rounded p-4 min-h-[300px] mb-8"
          style={{
            fontFamily: novelStyle.fontFamily,
            fontSize: novelStyle.fontSize,
            color: novelStyle.color,
            background: novelStyle.background,
            transition: 'all 0.2s',
          }}
        >
          {Array.isArray(currentChapter.content) ? (
            <div className="flex flex-col gap-4 items-center">
              {currentChapter.content.map((img: string, i: number) => (
                <img
                  key={i}
                  src={img}
                  alt={`page-${i+1}`}
                  className="w-full max-w-[600px] rounded shadow object-contain"
                  loading="lazy"
                  style={{background: '#222'}}
                />
              ))}
            </div>
          ) : currentChapter.content?.blocks ? (
            <div className="flex flex-col gap-4">
              {currentChapter.content.blocks.map((item: any, idx: number) => (
                <div 
                  key={item.id || idx}
                  dangerouslySetInnerHTML={{ __html: item.data?.text || '' }}
                />
              ))}
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: currentChapter.content || '' }} />
          )}
        </div>
      </>
    );
  };

  return (
    <div className="novel-reader bg-mainBlack min-h-screen text-white relative">
      {!hideUI && <Header isBack/>}
      <div className="max-w-2xl mx-auto pt-8 pb-24">
        <h1 className="text-2xl font-bold mb-2 text-center">{detail.title}</h1>
        {renderContent()}
      </div>
      <ChapterController
        currentIdx={currentIdx}
        chaptersArr={chaptersArr}
        goToChapter={goToChapter}
        slug={slug || ""}
        currentChapter={currentChapter || {}}
        hideUI={hideUI}
        setHideUI={setHideUI}
        type="novel"
      />
    </div>
  );
};

export default NovelReader;
